import type { FC } from "react";
import {
  Box,
  Button,
  Card,
  Divider,
  Group,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { IconBellRinging, IconEye } from "@tabler/icons-react";
import type { OrderPageState } from "../useOrderPage";
import { ICON_STROKE } from "./order-page-v2.utils";

const ACTION_ACCENT = "3px solid var(--mantine-color-amber-5)";

type OrderRequiredActionsProps = {
  state: OrderPageState;
  onReviewDesign: () => void;
};

export const OrderRequiredActions: FC<OrderRequiredActionsProps> = ({
  state,
  onReviewDesign,
}) => {
  if (!state.design.isAwaitingDentistReview) {
    return null;
  }

  return (
    <Card withBorder p={0} shadow="xs" role="status">
      <Group gap="s2" bg="appBackground" px="s5" py="s2">
        <IconBellRinging
          size={14}
          stroke={ICON_STROKE}
          color="var(--mantine-color-ink-5)"
        />
        <Text variant="overline">Ce qui attend votre réponse</Text>
      </Group>
      <Divider color="ink.1" />
      <Group
        wrap="nowrap"
        gap="s3"
        px="s5"
        py="s3"
        style={{ borderLeft: ACTION_ACCENT }}
      >
        <ThemeIcon variant="light" color="amber" size="md" radius="sm">
          <IconEye size={16} stroke={ICON_STROKE} />
        </ThemeIcon>
        <Box flex={1} miw={0}>
          <Text variant="strong">
            Un aperçu de conception est prêt à être validé
          </Text>
          <Text size="sm">Avant lancement en fabrication</Text>
        </Box>
        <Button
          size="sm"
          color="warning"
          leftSection={<IconEye size={14} stroke={ICON_STROKE} />}
          onClick={onReviewDesign}
        >
          Examiner
        </Button>
      </Group>
    </Card>
  );
};
